import { render, staticRenderFns } from "./SourceAffBlacklist.vue?vue&type=template&id=3a8383e3&"
import script from "./SourceAffBlacklist.vue?vue&type=script&lang=js&"
export * from "./SourceAffBlacklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports